export const DEFAULT_TIMEOUT_MS = 60000

export const Palette = {
  darkBlue: '#16164D',
  darkGreen: '#297F0D',
  darkGray: '#808080',
  darkYellow: '#E7B619',
  orange: '#F57350',
  navyBlue: '#38387C',
  green: '#56CC2B',
  gray: '#C0C0C0',
  yellow: '#FFD05A',
  fadedBlue: '#A1A1B7',
  fadedGreen: '#A9CB9E',
  fadedYellow: '#F9EECC',
}

export const chartPalette = Object.values(Palette)

export const MONTH_LIST_SHORT = [
  'JAN',
  'FEV',
  'MAR',
  'ABR',
  'MAI',
  'JUN',
  'JUL',
  'AGO',
  'SET',
  'OUT',
  'NOV',
  'DEZ',
]

export const DAY_HOURS_30_MINUTES_STEPS = [...new Array(24)]
  .map((_, idx) => idx.toString().padStart(2, '0'))
  .map((h) => [':00', ':30'].map((m) => h + m))
  .flat()

export const datetimeXAxis = [
  {
    dateTimeLabelFormats: {
      second: '%d/%m/%y<br/>%H:%M:%S',
      minute: '%d/%m/%y<br/>%H:%M',
      hour: '%d/%m/%y<br/>%H:%M',
      day: '%d/%m/%y',
      month: '%m/%y',
      year: '%Y',
    },
    type: 'datetime' as const,
  },
]
